import React from "react";

// Brand logo for CX10X — bubbly 3D-ish inline SVG.
// variant: "light" (colored on white bg) or "dark" (white on dark bg)
export function Logo({ size = 32, variant = "light", showText = true, className = "" }) {
  const orange = "#F58220";
  const orangeDark = "#E36F0E";
  const navy = "#1F3A6B";
  const navyDark = "#142A52";
  const wordOrange = variant === "dark" ? "#FFFFFF" : orange;
  const wordNavy = variant === "dark" ? "#FFFFFF" : navy;

  return (
    <div className={`inline-flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <svg width={size} height={size} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-label="CX10X logo">
        <defs>
          <radialGradient id="logo-orange" cx="30%" cy="30%" r="80%">
            <stop offset="0" stopColor="#FFB57B" />
            <stop offset="0.55" stopColor={orange} />
            <stop offset="1" stopColor={orangeDark} />
          </radialGradient>
          <radialGradient id="logo-navy" cx="30%" cy="30%" r="80%">
            <stop offset="0" stopColor="#4F6FA5" />
            <stop offset="0.55" stopColor={navy} />
            <stop offset="1" stopColor={navyDark} />
          </radialGradient>
        </defs>
        {/* Rounded squircle */}
        <rect x="4" y="4" width="56" height="56" rx="18" fill="url(#logo-orange)" />
        {/* Inner navy swirl */}
        <path d="M14 32c0-10 8-18 18-18 6 0 11 3 14 8-3-2-6-3-10-3-10 0-18 8-18 18 0 4 1 7 3 10-4-3-7-9-7-15z" fill="url(#logo-navy)" opacity="0.95"/>
        {/* CX letters — bubbly */}
        <text x="32" y="42" textAnchor="middle" fontFamily="Nunito, system-ui, sans-serif" fontWeight="900" fontSize="24" fill="#FFF7EE" style={{ paintOrder: "stroke" }} stroke="rgba(0,0,0,0.10)" strokeWidth="1">
          CX
        </text>
      </svg>
      {showText && (
        <div className="leading-none">
          <span className="font-black tracking-tight text-[1.05rem]" style={{ fontFamily: "Nunito, system-ui, sans-serif" }}>
            <span style={{ color: wordOrange }}>CX</span>
            <span style={{ color: wordNavy }}>10X</span>
          </span>
        </div>
      )}
    </div>
  );
}
